export default {
  title: "サポート",
  rules: {
    note: "お問い合わせを送信する前に、以下のルールをご確認ください：",
    rule_1: "1. まず{faq}（FAQ）をご確認ください。回答がすでに掲載されている場合があります。",
    rule_2: "2. お支払いに問題がある場合は、取引の詳細（日時、金額、支払い方法、スクリーンショット）を必ず添付してください。",
    rule_3: "3. ファイルのダウンロードに問題がある場合は、該当ファイルのリンクを必ず記載してください。",
    rule_4: "4. 著作権に関する問題、または規約に違反するファイルに関するお問い合わせは、こちらへご連絡ください：{email}",
    rule_5: "5. 協業、アフィリエイト、広告、その他のビジネス提案は、こちらへご連絡ください：{email}",
    rule_6: "6. 返信は内容の複雑さおよびサポートの混雑状況により、12時間〜2営業日ほどかかる場合があります。",
    rules: "規約",
    faq: "よくある質問"
  },
  messages: {
    note: "*直近{count}件のメッセージを表示しています",
    you: "あなた",
    support: "サポート",
    autoanswer_subject_is_over: "ご質問が解決しましたので、チャットを終了します。\nサポートセンターへのお問い合わせありがとうございました。"
  },
  inputs: {
    message: {
      placeholder: "ご質問を入力してください"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "ファイルを添付",
      attached_files: "添付ファイル："
    }
  },
  errors: {
    generic: "エラー",
    invalid_file_type: "対応していないファイル形式です。",
    max_file_size_limit: "ファイルサイズが大きすぎます。より小さいファイルを選択してください。",
    filename_too_long: "ファイル名が長すぎます",
    filename_invalid_chars: "ファイル名に無効な文字が含まれています"
  },
  btn: {
    send: "送信"
  }
};
